import { ExpenseType } from './ExpenseType';

export default class Expense {
    id: number;
    accountId?: number;
    voucherId?: number;
    voucherNumber?: number;

    // both
    description?: string;
    projectNumber?: number;
    clientNumber?: number;
    sectionNumber?: number;
    unitNumber?: number; 
    billingAccount?: string;
    expenseType?: ExpenseType;
    budgetCategoryName?: string;
    budgetSubcategoryName?: string;

    // for voucher expense
    accountNumber?: string;
    accountDescriptor?: string;
    amount?: number;

    // for cc expense
    ccTransactionNumber?: number;
    chargeDate?: Date;  
    chargeAmount?: number;
    chargedBy?: number;
    employeeName?: string;
    statementDescription?: string;
    glAccountNumber?: string;
}



// WEBPACK FOOTER //
// ./src/models/AP/Expense.ts